import styled from "styled-components";
import { Modal, Select, Button } from "antd";
import DatatableAntd from "components/datatable-antd";
import { hexToRgba } from "./utils";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalTableContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const CustomModal = styled(Modal)`
  position: relative;

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  td .ant-form-item {
    margin-bottom: 0;
  }

  td .ant-form-item-with-help .ant-form-item-explain {
    display: none;
  }

  td input[type=number], td input[type=date] {
    height: 2.4rem;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    max-height: calc(90vh - 12px);
    height: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

`;

export const ButtonAddItem = styled.button`
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    flex: 0 0 auto;
    width: auto;
    align-self: flex-start;

    background: #12619C;
    color: #fff;
    border: 1px solid #e0e0e0;

    :disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

`;

export const ContainerTable = styled.div`
  flex: 1;
  min-height: 0;

  /* overflow: auto; */

  /* padding-bottom: 25px; */

  > div > div > div > div > div,
  > div > div > div > div > div > div,
  .ant-table-cell:has(input) {
    overflow: visible !important;
  }

  .css-0, 
  .ant-table-wrapper, 
  .ant-spin-nested-loading, 
  .ant-spin-container, 
  .ant-table, 
  .ant-table-container {
    height: 100%;
  }

  position: relative;
  width: 100%;

  .ant-table {
    table-layout: fixed !important;
  }

  .ant-table-container {
    overflow: visible !important;
  }


.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  white-space: nowrap;
}

  .ant-select {
    cursor: text;
    min-width: 100px;
    border-radius: 0.375rem;
  }
  .ant-select-selector {
    height: 2.4rem;
  }
`;

export const ModalContainer = styled.div`
  padding: 12px 24px;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`

export const ContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ContentMdDelete = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
;
`

export const SelectAntdStyled = styled(Select)`
  .ant-select-selector {
    height: 2.5rem !important;
    border-radius: 0.375rem !important;
    padding: 4px 12px !important;
  }
  
  .ant-select-item .ant-select-item-option {
    font-size: 0.75rem;
  }
  
  input {
    padding: 10px 5px 2px 5px !important;
  }
  
`;

export const TimeLineIcon = styled.div<{ color: string }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;

  background: ${({ color }) => hexToRgba(color, 0.1)};
  border: 2px solid ${({ color }) => color};
  
  svg {
    font-size: 16px;
    color: ${({ color }) => color};
  }
`;

export const Type = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;

  background: ${({ color }) => hexToRgba(color, 0.1)};
  color: ${({ color }) => color};
  font-size: 10px;
  padding: 3px 6px;
`;

export const IconInfo = styled.span`
  font-size: 13px;
  display: inline-block;
  text-align: center;
  cursor: pointer;

  svg {
    font-size: 16px;
    color: #74b9ff;
  }

  &:hover svg {
    color: #0984e3 !important;
  }
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

export const ContentMd = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  button {
    padding: 4px 8px;
    border-radius: 6px;

    :disabled {
      opacity: 0.3 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
      filter: grayscale(100%);
    }

    
    svg {
      font: 16px;
      color: #fff;
      
    }
  }
  .cancel-operation {
     background-color: #e74c3c;
   }

   .previus-operation {
     background-color: #27ae60;
   }

   .next-operation {
     background-color: #f39c12;
   }

   .view-historic-operation {
     background-color: #74b9ff;
   }

   .check {
     background-color: #20a45a;
   }
   .swap {
     background-color: orange;
   }
`;